var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',_vm._b({class:['is-outlined is-light', _vm.roleNameClass, {'is-full-width': _vm.isFullWidth}]},'b-tag',_vm.$attrs,false),[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.roleNameDisplay,{ ignoreAcronym: true })))])])}
var staticRenderFns = []

export { render, staticRenderFns }